import React, { Component } from "react";

class ReferenceContactPolicyContent extends Component {
  render() {
    return (
      <section className="section testimonial-area ptb_100">
        <div className="container text-center">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-md-10 col-lg-8">
              <h2 className="mt-4 mb-3">Reference Contact Policy</h2>
              {/* <p className="mb-3">Last Updated on December 29, 2025</p> */}
              <div className="col-12 col-md-12 row">
                <h3 className="mt-2 mb-2 w-100 row justify-content-start">
                  1. Purpose
                </h3>
                <div style={{ textAlign: "start" }}>
                  Gathering feedback from reference contacts before granting a
                  loan is a standard industry practice that helps evaluate the
                  applicant’s credibility and identity. Our NBFC collects and
                  uses reference details responsibly and strictly for
                  verification and limited follow-up purposes, in compliance
                  with applicable laws and ethical standards. This policy
                  outlines the process for collecting and using reference
                  information, and the responsibilities, limitations, and
                  protections applicable to reference contacts.
                </div>
                <h3 className="mt-4 w-100 row justify-content-start">
                  2. Policy Guidelines
                </h3>
                <h3 className="mt-4 mb-2 w-100 row justify-content-start">
                  A. Mandatory Reference Contacts
                </h3>
                <ul style={{ textAlign: "left" }}>
                  <li className="mb-2">
                    • Providing reference contacts is mandatory for all loan
                    applications.
                  </li>
                  <li className="mb-2">
                    • Borrowers must ensure the accuracy and availability of
                    reference contact details.
                  </li>
                  <li className="mb-2">
                    • By providing reference details, the borrower confirms that
                    the reference contacts have been informed and have consented
                    to being contacted for verification and follow-up purposes.
                  </li>
                </ul>
                <h3 className="mt-4 mb-2 w-100 row justify-content-start">
                  B. Purpose of Collecting References
                </h3>
                <p style={{ textAlign: "start" }}>
                  Reference information is collected to:
                  <ul
                    style={{ textAlign: "left", paddingLeft: 20 }}
                    className="mt-2"
                  >
                    <li className="mb-2">
                      • Verify the applicant’s identity and authenticity.
                    </li>
                    <li className="mb-2">
                      • Gather limited feedback regarding the applicant’s
                      credibility and character.
                    </li>
                    <li className="mb-2">
                      • Serve as a secondary point of contact only if the
                      borrower becomes unreachable.
                    </li>
                  </ul>
                </p>
                <h3 className="mt-4 mb-2 w-100 row justify-content-start">
                  C. Responsibilities, Liabilities, and Terms for Reference
                  Contacts
                </h3>
                <p style={{ textAlign: "start" }}>
                  <span className="fw-6" style={{ color: "#000" }}>
                    Responsibilities of Reference Contacts
                  </span>
                  <ul
                    style={{ textAlign: "left", paddingLeft: 20 }}
                    className="mt-2"
                  >
                    <li className="mb-2">
                      • Reference contacts are not guarantors and have no
                      financial, legal, or repayment obligations in relation to
                      the loan.
                    </li>
                    <li className="mb-2">
                      • Reference contacts shall not be held responsible for any
                      default, non-payment, or breach by the borrower.
                    </li>
                  </ul>
                </p>
                <p style={{ textAlign: "start" }}>
                  <span className="fw-6" style={{ color: "#000" }}>
                    Liabilities of Reference Contacts
                  </span>
                  <ul
                    style={{ textAlign: "left", paddingLeft: 20 }}
                    className="mt-2"
                  >
                    <li className="mb-2">
                      • Reference contacts are expected to provide honest and
                      factual information to the best of their knowledge.
                    </li>
                    <li className="mb-2">
                      • Reference contacts shall not be held responsible for any
                      default, non-payment, or breach by the borrower.
                    </li>
                  </ul>
                </p>
                <p style={{ textAlign: "start" }}>
                  <span className="fw-6" style={{ color: "#000" }}>
                    Terms Applicable to Reference Contacts
                  </span>
                  <ul
                    style={{ textAlign: "left", paddingLeft: 20 }}
                    className="mt-2"
                  >
                    <li className="mb-2">
                      • Reference contacts will be informed that their role is
                      limited to verification and communication assistance only.
                    </li>
                    <li className="mb-2">
                      • They will not be pressured, coerced, or held accountable
                      for the borrower’s financial obligations.
                    </li>
                  </ul>
                </p>
                <h3 className="mt-4 mb-2 w-100 row justify-content-start">
                  D. Usage of Reference Information
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  Reference information may be used only for:
                  <ul
                    style={{ textAlign: "left", paddingLeft: 20 }}
                    className="mt-2"
                  >
                    <li className="mb-2">
                      • Verification of the borrower’s identity and application
                      details.
                    </li>
                    <li className="mb-2">
                      • Limited follow-up if the borrower is unreachable.
                    </li>
                    <li className="mb-2">
                      • Conveying factual repayment reminders strictly for the
                      purpose of reconnecting with the borrower, without
                      pressure, harassment, or coercion.
                    </li>
                  </ul>
                </p>
                <h3 className="mt-4 mb-2 w-100 row justify-content-start">
                  E. Communication with Reference Contacts
                </h3>
                <ul style={{ textAlign: "left" }} className="mt-2">
                  <li className="mb-2">
                    • Communication will be limited to verification or factual
                    follow-ups only.
                  </li>
                  <li className="mb-2">
                    • Contacts will be made only when necessary and during
                    reasonable hours.
                  </li>
                  <li className="mb-2">
                    • Communications shall always be professional, respectful,
                    and compliant with regulatory standards.
                  </li>
                  <li className="mb-2">
                    • No abusive, misleading, threatening, or coercive language
                    shall be used.
                  </li>
                </ul>
                <h3
                  className="mt-4 mb-2 w-100 row justify-content-start"
                  style={{ textAlign: "start" }}
                >
                  F. Regulatory Compliance and Data Protection
                </h3>{" "}
                <ul style={{ textAlign: "left" }} className="mt-2">
                  <li className="mb-2">
                    • All interactions shall comply with applicable RBI
                    guidelines, data protection laws, and consumer protection
                    regulations.
                  </li>
                  <li className="mb-2">
                    • Reference data will be treated as confidential, stored
                    securely, and accessed only by authorized personnel.
                  </li>
                  <li className="mb-2">
                    • Reference information shall not be shared with
                    unauthorized third parties.
                  </li>
                </ul>
                <h3 className="mt-4 mb-2 w-100 row justify-content-start">
                  G. Grievance Redressal
                </h3>{" "}
                <p style={{ textAlign: "start" }}>
                  If a reference contact or borrower has any concern regarding
                  communication or data usage, they may contact the NBFC’s
                  grievance redressal officer through the official support
                  channels.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ReferenceContactPolicyContent;
